import Component from '@cell/cell-core/component/component';
import './swatch-button.scss';

class SwatchButton extends Component {
  constructor() {
    super();

    this.elements = {
      input: this.querySelector('input'),
    };

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.elements.input.on('change', this.handleInputChange);
  }

  handleInputChange() {
    this.emit('change', {
      value: this.parsedDataset.value,
    });
  }
}

customElements.define('swatch-button', SwatchButton);
